export default __webpack_public_path__ + "media/images/icons/check-seal-a0415048f28c6fe7e6f6e0427e3de790.svg";